import { render, staticRenderFns } from "./SatelliteGis.vue?vue&type=template&id=6fd1078e&scoped=true"
import script from "./SatelliteGis.vue?vue&type=script&lang=js"
export * from "./SatelliteGis.vue?vue&type=script&lang=js"
import style0 from "./SatelliteGis.vue?vue&type=style&index=0&id=6fd1078e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd1078e",
  null
  
)

export default component.exports